import React, { useState, useEffect } from "react";
import "react-calendar/dist/Calendar.css";
import Slider from "react-slider";
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import {
  Button,
  Modal,
  Accordion,
  Offcanvas,
  Form,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import CustomPagination from "../CustomPagination/CustomPagination";
import "./Payment.css";
import { DateRange, DateRangePicker } from "react-date-range";
import { addDays, format } from "date-fns";
import "react-date-range/dist/styles.css";

import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils";
import error from "../../Utils/Icons/error";
import PremiumLoader from "../Loader/PremiumLoader";
import useKeyScroll from "../../Hooks/useKeyScroll";

export default function PaymentLayout() {
  const scrollContainerRef = useKeyScroll();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [showView, setShowView] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [selectedPaymentList, setSelectedPaymentList] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [methodsApplied, setMethodsApplied] = useState(0);
  const [packagesApplied, setPackagesApplied] = useState(0);
  const [filtersApplied, setFiltersApplied] = useState(0);
  const [amountRange, setAmountRange] = useState([0, 100000]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const [appliedFilters, setAppliedFilters] = useState({
    createdOn: null,
    paymentMethod: "",
    packageSubType: "",
    amountRange: [0, 100000]
  });

  const [filters, setFilters] = useState({
    packageSubType: "",
    createdOn: "",
    paymentMethod: "",
  });
  const today = new Date();
  const lastMonth = new Date();
  lastMonth.setDate(today.getDate() - 30);
  const [selectionRange, setSelectionRange] = useState({
    startDate: today,
    endDate: today,
    key: "selection",
  });
  const [activeQuickRange, setActiveQuickRange] = useState("");
  const [isDateFilterApplied, setIsDateFilterApplied] = useState(false);

  const handleSelect = (ranges) => {
    setSelectionRange({
      ...ranges.selection,
      key: "selection"
    });
    setActiveQuickRange("");
    setIsDateFilterApplied(true);
  };

  const handleQuickSelect = (type) => {
    const today = new Date();
    let start = today;
    let end = today;

    switch (type) {
      case "Today":
        break;
      case "Yesterday":
        start = addDays(today, -1);
        end = addDays(today, -1);
        break;
      case "This Week":
        start = addDays(today, -today.getDay());
        break;
      case "Last Week":
        start = addDays(today, -today.getDay() - 7);
        end = addDays(today, -today.getDay() - 1);
        break;
      case "This Month":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        break;
      case "Last Month":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        break;
    }

    setSelectionRange({
      startDate: start,
      endDate: end,
      key: "selection",
    });
    setActiveQuickRange(type);
    setIsDateFilterApplied(true);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseView = () => setShowView(false);
  const handleShowView = () => setShowView(true);

  const handleOpenViewWithLoader = () => {
    setActionLoading(true);
    setShowView(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleInvoiceDownload = (invoiceNumber) => {
    if (!invoiceNumber) {
      showToast("Invoice number is not available", "error", "error");
      return;
    }

    const downloadUrl = `/user/credit/invoice?invoiceNumber=${invoiceNumber}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleMethodChange = (newMethod, isChecked) => {
    if (isChecked) {
      setSelectedMethod([newMethod]);
    } else {
      setSelectedMethod([]);
    }
  };

  const handlePackageChange = (newPackage, isChecked) => {
    if (isChecked) {
      setSelectedPackages([newPackage]);
    } else {
      setSelectedPackages([]);
    }
  };

  const handleAmountRangeChange = (value) => {
    setAmountRange(value);
  };

  const calculateFiltersApplied = () => {
    let count = 0;
    if (isDateFilterApplied) count++;
    count += selectedPackages.length;
    count += selectedMethod.length;
    if (amountRange[0] !== 0 || amountRange[1] !== 100000) count++;
    setFiltersApplied(count);
  };

  const calculatePackagesApplied = () => {
    setPackagesApplied(selectedPackages.length);
    setMethodsApplied(selectedMethod.length);
  };

  // const handleApplyFilters = () => {
  //   calculateFiltersApplied();
  //   calculatePackagesApplied();
  //   handleClose();
  // };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleApplyFilters = () => {
    calculateFiltersApplied();
    calculatePackagesApplied();
    handleClose();
    setCurrentPage(1);

    setAppliedFilters({
      createdOn: isDateFilterApplied && selectionRange.startDate && selectionRange.endDate
        ? {
          startDate: selectionRange.startDate.toISOString().split("T")[0],
          endDate: selectionRange.endDate.toISOString().split("T")[0],
        }
        : null,
      paymentMethod: selectedMethod.length ? selectedMethod[0] : "",
      packageSubType: selectedPackages.length ? selectedPackages[0] : "",
      amountRange,
    });
  };

  const handleClearFilters = () => {
    setFiltersApplied(0);
    const today = new Date();
    setSelectionRange({
      startDate: today,
      endDate: today,
      key: "selection",
    });
    setActiveQuickRange("");
    setIsDateFilterApplied(false);
    setSelectedPackages([]);
    setSelectedMethod([]);
    setMethodsApplied(0);
    setPackagesApplied(0);
    setAmountRange([0, 100000]);

    setCurrentPage(1);
    setAppliedFilters({
      createdOn: null,
      paymentMethod: "",
      packageSubType: "",
      amountRange: [0, 100000]
    });
  };

  useEffect(() => {
    const fetchPaymentsData = async () => {
      setListLoading(true);
      const payload = {
        pageNumber: currentPage,
        pageSize: rowsPerPage,
      };

      if (sortConfig.key) {
        payload.orderBy = sortConfig.key;
        payload.orderByType = sortConfig.direction === "ascending" ? "ASC" : "DESC";
      }

      if (appliedFilters.createdOn) {
        payload.createdOn = appliedFilters.createdOn;
      }
      if (appliedFilters.paymentMethod) {
        payload.paymentMethod = appliedFilters.paymentMethod;
      }
      if (appliedFilters.packageSubType) {
        payload.packageSubType = appliedFilters.packageSubType;
      }
      if (appliedFilters.amountRange && (appliedFilters.amountRange[0] !== 0 || appliedFilters.amountRange[1] !== 100000)) {
        payload.amountRange = appliedFilters.amountRange;
      }

      try {
        const response = await Instance.post("/user/paymentHistory", payload);
        if (response.data.resCode === "200") {
          setPaymentData(response.data.message || []);
          setTotalPages(response.data.totalPages || 1);
          setTotalRecords(response.data.totalRecord || 0);
        } else if (response.data.resCode === "120") {
          setPaymentData([]);
          setTotalPages(1);
          setTotalRecords(0);
        } else {
          console.error("Failed to fetch payment data:", response.data.resMessage);
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
      } finally {
        setLoading(false);
        setListLoading(false);
      }
    };

    fetchPaymentsData();
  }, [currentPage, rowsPerPage, sortConfig, appliedFilters]);

  const fetchPaymentDetail = (id) => {
    const detail = paymentData.find((item) => item.id === id);
    if (detail) {
      setPaymentDetails(detail);
      return;
    }

    const token = localStorage.getItem("tokenId");
    Instance.post("/user/paymentHistory", {
      // tokenId: token,
      id: id,
    })
      .then((response) => {
        if (response.data.message && response.data.message.length > 0) {
          setPaymentDetails(response.data.message[0]);
        }
      })
      .catch((error) => {
        console.error("error fetching the payments data", error);
      });
  };



  useEffect(() => {
    if (paymentData.length > 0) {
      fetchPaymentDetail(paymentData[0].id);
    }
  }, [paymentData]);

  // const handleSelectId = (id) => {
  //   fetchPaymentDetail(id);
  //   setSelectedPaymentList(id);
  // };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  const currentPaymentData = Array.isArray(paymentData) ? paymentData : [];

  const handleSortChange = (selectedColumn) => {
    setSortConfig((prev) => ({
      key: selectedColumn.sortField,
      direction:
        prev.key === selectedColumn.sortField &&
          prev.direction === "ascending"
          ? "descending"
          : "ascending",
    }));

    setCurrentPage(1);
  };

  const renderSortIcon = (field) => {
    if (sortConfig.key !== field) {
      return (
        <FontAwesomeIcon
          icon={faArrowDown}
          style={{ marginLeft: 6, opacity: 0.3 }}
        />
      );
    }

    return (
      <FontAwesomeIcon
        icon={
          sortConfig.direction === "ascending"
            ? faArrowUp
            : faArrowDown
        }
        style={{ marginLeft: 6, opacity: 1 }}
      />
    );
  };

  const currentSortedPayment = currentPaymentData;

  const columns = React.useMemo(() => [
    {
      name: <div style={{ display: 'flex', alignItems: 'center' }}>TRANSACTION ID {renderSortIcon('transactionId')}</div>,
      selector: row => row.transactionId,
      sortable: true,
      sortField: 'transactionId',
      width: '240px',
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <input
            type="checkbox"
            className="ticket_checkbox"
            checked={paymentDetails?.id === row.id}
            readOnly
          />
          {row.transactionId}
        </div>
      ),
    },
    {
      name: <div style={{ display: 'flex', alignItems: 'center' }}>PACKAGE NAME {renderSortIcon('packageName')}</div>,
      selector: row => row.packageName,
      sortable: true,
      sortField: 'packageName',
      width: '250px',
      cell: (row, index) => (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-table-${index}`}>
              {row.packageName}
            </Tooltip>
          }
        >
          <div className="truncate_text" style={{ maxWidth: "200px" }}>
            {row.packageName}
          </div>
        </OverlayTrigger>
      ),
    },
    {
      name: <div style={{ display: 'flex', alignItems: 'center' }}>DATE OF PURCHASE {renderSortIcon('createdOn')}</div>,
      selector: row => row.createdOn,
      sortable: true,
      sortField: 'createdOn',
      width: '200px',
      cell: row => row.createdOn ? format(new Date(row.createdOn), "MMM d, yyyy • h:mm a") : "",
    },
    {
      name: <div style={{ display: 'flex', alignItems: 'center' }}>PAYMENT METHOD {renderSortIcon('paymentMethod')}</div>,
      selector: row => row.paymentMethod,
      sortable: true,
      sortField: 'paymentMethod',
      width: '180px',
      cell: row => (
        <div className="d-flex align-items-center justify-content-start">
          <div
            className={
              row.paymentMethod === "netbanking"
                ? "method_ib"
                : row.paymentMethod === "OPTNBK"
                  ? "method_upi"
                  : "method_cc"
            }
          >
            {row.paymentMethod}
          </div>
        </div>
      ),
    },
    {
      name: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          STATUS {renderSortIcon('status')}
        </div>
      ),
      selector: row => row.status,
      sortable: true,
      sortField: 'status',
      center: true,
      width: '150px',
      style: { justifyContent: 'center' },
      headerStyle: { justifyContent: 'center' },
      cell: row => (
        <div className="payment-table-center-cell">
          <div className={`status_badge ${row.status?.toLowerCase()}`}>
            {row.status}
          </div>
        </div>
      ),
    },
  ], [sortConfig, paymentDetails]);

  const customStyles = {
    table: {
      style: {
        minWidth: 'max-content',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        minHeight: '52px',
        minWidth: 'max-content',
      },
    },
    headCells: {
      style: {
        fontSize: '13px',
        textTransform: 'uppercase',
        fontWeight: '700',
        color: '#444444',
        flexShrink: 0,
        borderRight: 'none',
      },
    },
    cells: {
      style: {
        color: '#6c757d',
        fontSize: '14px',
        fontWeight: '500',
        whiteSpace: 'normal',
        flexShrink: 0,
        borderRight: 'none',
      },
    },
    rows: {
      style: {
        minHeight: '70px',
        minWidth: 'max-content',
      },
      highlightOnHoverStyle: {
        backgroundColor: '#f5f6ff',
        outline: 'none',
        transition: 'background-color 0.2s ease',
      },
    },
  };

  return (
    <>
      <div className="paymemt_content">
        {actionLoading && (
          <div className="payment_action_loader">
            <PremiumLoader fullPage={false} text="Please wait..." />
          </div>
        )}
        {loading ? (
          <PremiumLoader fullPage={false} text="Fetching transaction history..." />
        ) : (
          <>
            <div className={`payment_list ${currentPaymentData.length === 0 ? "w-100" : ""}`}>
              <div className="payment_filter d-flex align-items-center gap-3">
                <Button
                  variant="primary"
                  className="Payment_filter_btn"
                  onClick={handleShow}
                >
                  Filter
                  <img
                    className="filter_img"
                    src="/build/img/Icons/down_vector.svg"
                    alt="zex pr wire Logo"
                    width={16}
                    height={16}

                  />
                </Button>
                <Offcanvas show={show} onHide={handleClose} placement="start" className="filter_offcanvas">
                  <Offcanvas.Header closeButton className="filter_offcanvas_header">
                    <Offcanvas.Title className="filter_offcanvas_title">
                      {filtersApplied} filters applied
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body className="filter_offcanavas_body">
                    <Accordion alwaysOpen flush>
                      <Accordion.Item eventKey="0" className="accordian_item">
                        <Accordion.Header className="filter_accordian">
                          Date Range
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="quick_ranges_container">
                            {["Today", "Yesterday", "This Week", "Last Week", "This Month", "Last Month"].map((label) => (
                              <button
                                key={label}
                                className={`quick_range_btn ${activeQuickRange === label ? "active" : ""}`}
                                onClick={() => handleQuickSelect(label)}
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                          <div className="date_picker_container">
                            <DateRange
                              ranges={[selectionRange]}
                              onChange={handleSelect}
                              months={1}
                              direction="horizontal"
                              maxDate={new Date()}
                              showMonthAndYearPickers={true}
                              moveRangeOnFirstSelection={false}
                              navigatorRenderer={(focusedDate, changeShownDate) => {
                                const months = [
                                  "January", "February", "March", "April", "May", "June",
                                  "July", "August", "September", "October", "November", "December"
                                ];
                                const currentYear = new Date().getFullYear();
                                const years = Array.from({ length: 50 }, (_, i) => currentYear - 25 + i);

                                return (
                                  <div className="rdrMonthAndYearPickers custom_nav_pickers">
                                    <div className="calendar_nav_wrapper">
                                      <Dropdown onSelect={(m) => changeShownDate(new Date(focusedDate.setMonth(parseInt(m))))}>
                                        <Dropdown.Toggle variant="light" className="calendar_nav_btn">
                                          {months[focusedDate.getMonth()]}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="calendar_nav_menu scrollable_menu">
                                          {months.map((m, i) => (
                                            <Dropdown.Item key={m} eventKey={i}>{m}</Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>

                                    <div className="calendar_nav_wrapper">
                                      <Dropdown onSelect={(y) => changeShownDate(new Date(focusedDate.setFullYear(parseInt(y))))}>
                                        <Dropdown.Toggle variant="light" className="calendar_nav_btn">
                                          {focusedDate.getFullYear()}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="calendar_nav_menu scrollable_menu">
                                          {years.map((y) => (
                                            <Dropdown.Item key={y} eventKey={y}>{y}</Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                );
                              }}
                            />
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1" className="accordian_item">
                        <Accordion.Header className="filter_accordian">
                          <span>Payment methods</span>
                          <span className="filter_accordian_text">
                            {methodsApplied} selected
                          </span>
                        </Accordion.Header>
                        <Accordion.Body className="filter_package_body">
                          <Form
                            value={filters.paymentMethod}
                            onChange={handleFilterChange}
                          >
                            <div className="">
                              <Form.Check
                                label="All"
                                name="paymentMethod"
                                type="radio"
                                id={`default-method-1`}
                                checked={selectedMethod.includes("")}
                                onChange={(e) =>
                                  handleMethodChange("", e.target.checked)
                                }
                              />
                              <Form.Check
                                label="Net Banking"
                                name="paymentMethod"
                                type="radio"
                                id={`default-method-2`}
                                checked={selectedMethod.includes("netbanking")}
                                onChange={(e) =>
                                  handleMethodChange(
                                    "netbanking",
                                    e.target.checked
                                  )
                                }
                              />
                              <Form.Check
                                label="OPTNBK"
                                name="paymentMethod"
                                type="radio"
                                id={`default-method-3`}
                                checked={selectedMethod.includes("OPTNBK")}
                                onChange={(e) =>
                                  handleMethodChange("OPTNBK", e.target.checked)
                                }
                              />
                              <Form.Check
                                label="Card"
                                name="paymentMethod"
                                type="radio"
                                id={`default-method-4`}
                                checked={selectedMethod.includes("card")}
                                onChange={(e) =>
                                  handleMethodChange("card", e.target.checked)
                                }
                              />
                            </div>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2" className="accordian_item">
                        <Accordion.Header className="filter_accordian">
                          <span>Packages</span>
                          <span className="filter_accordian_text">
                            {packagesApplied} selected
                          </span>
                        </Accordion.Header>
                        <Accordion.Body
                          className="filter_package_body"
                        >
                          <Form
                            value={filters.packageSubType}
                            onChange={handleFilterChange}
                          >
                            <div className="">
                              <Form.Check
                                label="All packages"
                                name="packageSubType"
                                type="radio"
                                id={`default-pkg-1`}
                                checked={selectedPackages.includes("")}
                                onChange={(e) =>
                                  handlePackageChange("", e.target.checked)
                                }
                              />
                              <Form.Check
                                label="Normal Package "
                                name="packageSubType"
                                type="radio"
                                id={`default-pkg-2`}
                                checked={selectedPackages.includes("NORMAL")}
                                onChange={(e) =>
                                  handlePackageChange("NORMAL", e.target.checked)
                                }
                              />
                              <Form.Check
                                label="Reseller Package "
                                name="packageSubType"
                                type="radio"
                                id={`default-pkg-3`}
                                checked={selectedPackages.includes("RESELLER")}
                                onChange={(e) =>
                                  handlePackageChange(
                                    "RESELLER",
                                    e.target.checked
                                  )
                                }
                              />
                              <Form.Check
                                label="Crypto Package "
                                name="packageSubType"
                                type="radio"
                                id={`default-pkg-4`}
                                checked={selectedPackages.includes("crypto")}
                                onChange={(e) =>
                                  handlePackageChange("crypto", e.target.checked)
                                }
                              />
                              <Form.Check
                                label="Indian PR Package "
                                name="packageSubType"
                                type="radio"
                                id={`default-pkg-5`}
                                checked={selectedPackages.includes("indianPR")}
                                onChange={(e) =>
                                  handlePackageChange(
                                    "indianPR",
                                    e.target.checked
                                  )
                                }
                              />
                              <Form.Check
                                label="White Label PR Package "
                                name="packageSubType"
                                type="radio"
                                id={`default-pkg-6`}
                                checked={selectedPackages.includes("whitelabel")}
                                onChange={(e) =>
                                  handlePackageChange(
                                    "whitelabel",
                                    e.target.checked
                                  )
                                }
                              />
                            </div>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3" className="accordian_item">
                        <Accordion.Header className="filter_accordian">
                          Amount range
                        </Accordion.Header>
                        <Accordion.Body className="filter_package_body">
                          <Slider
                            onChange={handleAmountRangeChange}
                            className="amount_slider"
                            value={amountRange}
                            min={0}
                            max={100000}
                            renderTrack={(props, state) => {
                              const { key, ...rest } = props;
                              return (
                                <div
                                  key={key}
                                  {...rest}
                                  className={`slider-track ${state.index === 1
                                    ? "track-active"
                                    : "track-inactive"
                                    }`}
                                />
                              );
                            }}
                          />
                          <div className={"amount_value"}>
                            <div className="value_min">$ {amountRange[0]}</div>
                            <div className="value_max">$ {amountRange[1]}</div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <div className="mt-4 mb-4 filter_btns">
                      <button
                        className="filter_clear_btn"
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      <button
                        className="filter_apply_btn"
                        onClick={handleApplyFilters}
                      >
                        Apply
                      </button>
                    </div>
                  </Offcanvas.Body>
                </Offcanvas>
                <div className="d-flex align-items-center flex-wrap ms-2 gap-2">
                  {filtersApplied > 0 && (
                    <div className="d-flex align-items-center border rounded-pill px-3 py-1" style={{ fontSize: '13px', color: '#d9534f', borderColor: '#d9534f', backgroundColor: '#fdf2f2' }}>
                      <span className="me-2 fw-medium">
                        {filtersApplied} filters applied
                      </span>
                      <span
                        aria-hidden="true"
                        style={{ cursor: "pointer", fontSize: "18px", lineHeight: "1", marginLeft: "4px" }}
                        onClick={handleClearFilters}
                      >
                        &times;
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="payment-table-container">
                <div
                  className="payment-table-scroll-wrapper"
                  ref={scrollContainerRef}
                  tabIndex="0"
                  style={{ outline: 'none' }}
                >
                  {listLoading ? (
                    <div className="text-center py-5 d-flex align-items-center justify-content-center" style={{ minHeight: '400px' }}>
                      <PremiumLoader fullPage={false} text="Updating list..." />
                    </div>
                  ) : currentSortedPayment.length === 0 ? (
                    <div className="payment-empty-state m-4">
                      <img src="/build/img/Pricing.svg" alt="No Payment" width="48" height="48" className="mb-3 opacity-20" />
                      <p className="payment-empty-state-text">No transactions found</p>
                      <button
                        className="payment-buy-now-btn"
                        onClick={() => (window.location.href = "/customer/pricing")}
                      >
                        Buy PR Credit
                      </button>
                    </div>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={currentSortedPayment}
                      customStyles={customStyles}
                      sortServer
                      onSort={handleSortChange}
                      sortIcon={<></>}
                      highlightOnHover
                      pointerOnHover
                      dense={false}
                      onRowClicked={(row) => fetchPaymentDetail(row.id)}
                      conditionalRowStyles={[
                        {
                          when: row => paymentDetails?.id === row.id,
                          style: {
                            backgroundColor: '#f1f2fd',
                          },
                        }
                      ]}
                      className="payment-table-react"
                    />
                  )}
                </div>

                <div className="payment-table-footer-pagination">
                  <CustomPagination
                    totalItems={totalRecords}
                    totalPages={totalPages}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                </div>
              </div>
            </div>
            {currentPaymentData.length > 0 && (
              <div className="payment_invoice">
                <>
                  <div className="invoice_details">
                    <h4 className="mb-4">Invoice</h4>
                    <div className="package_detail">
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Package Name</span>
                        <span className="invoice_detail_output">{paymentDetails.packageName}</span>
                      </div>
                      {paymentDetails.invoiceNumber && (
                        <div className="invoice_item_row">
                          <span className="invoice_detail_input">Invoice Number</span>
                          <span className="invoice_detail_output" style={{ fontWeight: '600', color: '#585edb' }}>
                            {paymentDetails.invoiceNumber}
                          </span>
                        </div>
                      )}
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Transaction Id</span>
                        <span className="invoice_detail_output">{paymentDetails.transactionId}</span>
                      </div>
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Date of Purchase</span>
                        <span className="invoice_detail_output">
                          {paymentDetails.createdOn ? format(new Date(paymentDetails.createdOn), "MMM d, yyyy • h:mm a") : ""}
                        </span>
                      </div>
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Status</span>
                        <div className={`status_badge ${paymentDetails.status?.toLowerCase()}`}>
                          {paymentDetails.status}
                        </div>
                      </div>
                    </div>
                    <div className="amount_details">
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Coupon Code</span>
                        <span className="invoice_detail_output" style={{ color: !paymentDetails.couponCode ? '#ef4444' : '#22c55e', fontWeight: '600' }}>
                          {paymentDetails.couponCode || "N/A"}
                        </span>
                      </div>
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Coupon discount</span>
                        <span className="invoice_detail_output" style={{ color: !paymentDetails.discountValue || paymentDetails.discountValue == "0" || paymentDetails.discountValue == "0.00" ? '#ef4444' : '#22c55e', fontWeight: '600' }}>
                          ${paymentDetails.discountValue || "0.00"}
                        </span>
                      </div>
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Payment method</span>
                        <div
                          className={`${paymentDetails.paymentMethod === "netbanking"
                            ? "method_ib"
                            : paymentDetails.paymentMethod === "OPTNBK"
                              ? "method_upi"
                              : "method_cc"
                            }`}
                        >
                          {paymentDetails.paymentMethod}
                        </div>
                      </div>
                      <div className="invoice_item_row">
                        <span className="invoice_detail_input">Package Amount</span>
                        <span className="invoice_detail_output">${paymentDetails.packageAmount}</span>
                      </div>
                    </div>
                    <div className="invoice_total">
                      <h5>Total Amount</h5>
                      <p>
                        {/* ${paymentDetails.amount - (paymentDetails.discountValue || 0)} */}
                        ${paymentDetails.totalAmount}
                      </p>
                    </div>
                  </div>
                  <div className="invoice_btns">
                    <button
                      className="view_invoice"
                      onClick={handleOpenViewWithLoader}
                    >
                      View
                    </button>
                    <Modal
                      show={showView}
                      onHide={handleCloseView}
                      centered
                      dialogClassName="payment-view-modal"
                      onEntered={() => setActionLoading(false)}
                      onExit={() => setActionLoading(false)}
                    >
                      <Modal.Header
                        closeButton
                        className="payment-modal-head"
                      >
                        <Modal.Title className="payment-modal-title">
                          Invoice details
                        </Modal.Title>
                      </Modal.Header>

                      <Modal.Body className="payment-modal-body">
                        <div className="payment-invoice-modal-content">
                          <div className="payment-invoice-modal-section">
                            <h6 className="payment-invoice-modal-section-title">Package Details</h6>
                            <div className="payment-invoice-modal-grid">
                              <div className="payment-invoice-modal-field payment-invoice-modal-field--full">
                                <span className="payment-invoice-modal-label">Package Name</span>
                                <span className="payment-invoice-modal-value">{paymentDetails.packageName || "N/A"}</span>
                              </div>
                              {paymentDetails.invoiceNumber && (
                                <div className="payment-invoice-modal-field payment-invoice-modal-field--full">
                                  <span className="payment-invoice-modal-label">Invoice Number</span>
                                  <span className="payment-invoice-modal-value payment-invoice-modal-value--mono">
                                    {paymentDetails.invoiceNumber}
                                  </span>
                                </div>
                              )}
                              <div className="payment-invoice-modal-field payment-invoice-modal-field--full">
                                <span className="payment-invoice-modal-label">Transaction ID</span>
                                <span className="payment-invoice-modal-value payment-invoice-modal-value--mono">
                                  {paymentDetails.transactionId || "N/A"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Date of Purchase</span>
                                <span className="payment-invoice-modal-value">
                                  {paymentDetails.createdOn
                                    ? format(new Date(paymentDetails.createdOn), "MMM d, yyyy • h:mm a")
                                    : "N/A"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Status</span>
                                <div className="payment-invoice-modal-badge-field">
                                  <span className={`status_badge ${paymentDetails.status?.toLowerCase()}`}>
                                    {paymentDetails.status || "N/A"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="payment-invoice-modal-section">
                            <h6 className="payment-invoice-modal-section-title">Payment & Discount</h6>
                            <div className="payment-invoice-modal-grid">
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Payment Method</span>
                                <div className="payment-invoice-modal-badge-field">
                                  <span
                                    className={`${paymentDetails.paymentMethod === "netbanking"
                                      ? "method_ib"
                                      : paymentDetails.paymentMethod === "OPTNBK"
                                        ? "method_upi"
                                        : "method_cc"
                                      }`}
                                  >
                                    {paymentDetails.paymentMethod || "N/A"}
                                  </span>
                                </div>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Coupon Code</span>
                                <span
                                  className={`payment-invoice-modal-value ${paymentDetails.couponCode ? "payment-invoice-modal-value--success" : "payment-invoice-modal-value--muted"}`}
                                >
                                  {paymentDetails.couponCode || "N/A"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Coupon Discount</span>
                                <span
                                  className={`payment-invoice-modal-value ${paymentDetails.discountValue && paymentDetails.discountValue !== "0" && paymentDetails.discountValue !== "0.00"
                                    ? "payment-invoice-modal-value--success"
                                    : "payment-invoice-modal-value--muted"
                                    }`}
                                >
                                  ${paymentDetails.discountValue || "0.00"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Package Amount</span>
                                <span className="payment-invoice-modal-value">
                                  ${paymentDetails.packageAmount || "0.00"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Payable Amount</span>
                                <span className="payment-invoice-modal-value payment-invoice-modal-value--amount">
                                  ${paymentDetails.totalAmount || "0.00"}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="payment-invoice-modal-section">
                            <h6 className="payment-invoice-modal-section-title">Package Validity</h6>
                            <div className="payment-invoice-modal-grid">
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Validity</span>
                                <span className="payment-invoice-modal-value">
                                  {paymentDetails.packageValidity || "N/A"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">Start Date</span>
                                <span className="payment-invoice-modal-value">
                                  {paymentDetails.start_date || "N/A"}
                                </span>
                              </div>
                              <div className="payment-invoice-modal-field">
                                <span className="payment-invoice-modal-label">End Date</span>
                                <span className="payment-invoice-modal-value">
                                  {paymentDetails.endDate || "N/A"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="payment-modal-footer">
                        <Button className="payment-modal-close-btn" onClick={handleCloseView}>
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    {paymentDetails?.invoiceNumber && (
                      <button
                        className="download_invoice"
                        onClick={() => handleInvoiceDownload(paymentDetails.invoiceNumber)}
                      >
                        Download
                      </button>
                    )}
                  </div>
                </>
              </div>
            )}
          </>
        )}
      </div >
    </>
  );
}
